module.exports = "/assets/26680a0b656bfe7a770be4dc7e631f93.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/3U.png
// module id = 2152
// module chunks = 0